import type {
    KcContext_LoginUsername,
    KcContext_MagicLinkConfirm,
    KcContext_MagicLinkForm,
} from './kc-context/kc-context';
import type { KcContext } from 'keycloakify/login/KcContext';
import { i18nBuilder } from 'keycloakify/login/i18n';

import { translations } from 'src/shared/translations/translations.js';

// Derive the custom theme message key union from English base (assumes superset across locales)
type ThemeMessageKey = keyof (typeof translations)['en'];

// Conform to expected shape: Partial<Record<LanguageTag, Record<ThemeMessageKey, string>>>
const messagesByLanguageTag_themeDefined: Partial<Record<string, Record<ThemeMessageKey, string>>> = Object.fromEntries(
    Object.entries(translations).map(([languageTag, msgs]) => [languageTag, msgs as Record<ThemeMessageKey, string>]),
);

// Provide generics so msgStr() is aware of ThemeMessageKey
const { useI18n } = i18nBuilder.withCustomTranslations<ThemeMessageKey>(messagesByLanguageTag_themeDefined).build();

type KcContextLike = KcContext | KcContext_LoginUsername | KcContext_MagicLinkForm | KcContext_MagicLinkConfirm;

export const useGetMsg = (kcContext: KcContextLike) => useI18n({ kcContext }).i18n;
